import { render } from "./EmptyDialogsPlaceholder.vue?vue&type=template&id=7484795a&scoped=true"
const script = {}

import "./EmptyDialogsPlaceholder.vue?vue&type=style&index=0&id=7484795a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7484795a"]])

export default __exports__